import * as React from 'react';
import { Text } from '@shared/ui-components';

import { PaymentConstants } from 'common/constants/payment';
import { Styled } from './styled';


interface Props {
  item: string;
  unit: number;
  unitPrice: number;
  amount: number;
}


export const  TableCell: React.FC<Props> = ({ item, unit, unitPrice, amount }: Props) => {
  return (
    <Styled.RowContainer>
      <Styled.Cell>
        <Styled.ContentWrapper isItem={true}>
          <Text>{item}</Text>
        </Styled.ContentWrapper>
      </Styled.Cell>
      <Styled.Cell>
        <Text>{unit}</Text>
      </Styled.Cell>
      <Styled.Cell>
        <Styled.ContentWrapper>
          <Text>{PaymentConstants.defaultCurrency}{unitPrice}</Text>
        </Styled.ContentWrapper>
      </Styled.Cell>
      <Styled.Cell>
        <Styled.ContentWrapper>
          <Text>{PaymentConstants.defaultCurrency}{amount}</Text>
        </Styled.ContentWrapper>
      </Styled.Cell>
    </Styled.RowContainer>
  );
};
